import React from 'react';

type BadgeVariant = 'positive' | 'warning' | 'danger' | 'info' | 'neutral';

interface StatusBadgeProps {
  label: string;
  variant: BadgeVariant;
  dot?: boolean;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  positive: 'bg-positive/10 text-positive border border-positive/20',
  warning: 'bg-warning/10 text-warning border border-warning/20',
  danger: 'bg-danger/10 text-danger border border-danger/20',
  info: 'bg-info/10 text-info border border-info/20',
  neutral: 'bg-muted text-muted-foreground border border-border',
};

const dotClasses: Record<BadgeVariant, string> = {
  positive: 'bg-positive',
  warning: 'bg-warning',
  danger: 'bg-danger',
  info: 'bg-info',
  neutral: 'bg-muted-foreground',
};

export default function StatusBadge({ label, variant, dot = false, className = '' }: StatusBadgeProps) {
  return (
    <span data-component-id="src/components/ui/StatusBadge.tsx:30:4" data-component-path="src/components/ui/StatusBadge.tsx" data-component-line="30" data-component-end-line="35" data-component-file="StatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold ${variantClasses[variant]} ${className}`}
    >
      {dot && <span data-component-id="src/components/ui/StatusBadge.tsx:33:14" data-component-path="src/components/ui/StatusBadge.tsx" data-component-line="33" data-component-end-line="33" data-component-file="StatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotClasses[variant]}`} />}
      {label}
    </span>
  );
}